// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2AdXJ","savePackageButton":"ClientWallet_savePackageButton__1BsA4"};